"use client"

import { useState, useEffect } from "react"
import { cn } from "@/lib/utils"

export function TableOfContents({ items = [] }) {
  const [activeId, setActiveId] = useState(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id)
          }
        }
      },
      { rootMargin: "-80px 0px -70% 0px" }
    )

    for (const item of items) {
      const el = document.getElementById(item.id)
      if (el) observer.observe(el)
    }

    return () => observer.disconnect()
  }, [items])

  if (items.length === 0) return null

  return (
    <nav className="space-y-1">
      <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-3">
        On this page
      </p>
      {items.map((item) => (
        <a
          key={item.id}
          href={`#${item.id}`}
          className={cn(
            "block text-sm leading-relaxed transition-colors hover:text-foreground",
            item.depth === 3 && "pl-4",
            activeId === item.id
              ? "font-medium text-primary"
              : "text-muted-foreground"
          )}
        >
          {item.label}
        </a>
      ))}
    </nav>
  )
}
